import { render } from "./WalletButton.vue?vue&type=template&id=477cfef6"
import script from "./WalletButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "477cfef6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('477cfef6', __exports__)) {
    api.reload('477cfef6', __exports__)
  }
  
  module.hot.accept("./WalletButton.vue?vue&type=template&id=477cfef6", () => {
    api.rerender('477cfef6', render)
  })

}


export default __exports__